'use strict'

export default class ImageCleaner {
    constructor () {
        this.radioInput = 'form[name=configuration_form] input[type=radio]'
        this.imagesWrapper = 'configurator-images-container'

        this.setUpListeners()
    }

    setUpListeners () {
        const radioButtons = document.querySelectorAll(this.radioInput)

        for (let i = 0; i < radioButtons.length; i++) {
            radioButtons[i].addEventListener('click', (event) => {
                this.setCurrentImageValue(event.target)

                this.hideImage()
            }, false)
        }
    }

    setCurrentImageValue(input) {
        this.currentImageValue = input.value
    }

    hideImage () {
        const imagesWrapper = document.getElementById(this.imagesWrapper)
        const images = imagesWrapper.getElementsByTagName('img')

        for (let i = 0; i < images.length; i++) {
            this.currentImageParent = images[i].parentElement
            this.currentImageParentDataColorId = this.currentImageParent.dataset.colorid

            if (this.radioButtonValueEqualsImageDataId()) {
                this.hideCurrentImage()
            }
        }
    }

    radioButtonValueEqualsImageDataId () {
        return this.currentImageValue === this.currentImageParentDataColorId
    }

    hideCurrentImage () {
        this.currentImageParent.style.display = 'none'
    }
}



// WEBPACK FOOTER //
// ./assets/js/utils/image-cleaner.js